var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"ySGMZN4hGAN7z1hSPVpDR"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/cleword-client-auth-next";

import initSentry from './sentry.base.config'

initSentry()